import React, { Component } from "react";
import { Form, Popover, OverlayTrigger } from 'react-bootstrap'
import { IToolTipOption } from "../classes/Domain";
import Utilities from "../classes/Utilities";

type Style = {
    display: 'none' | '';
}


type RadioButtonProps = {
    lable: string,
    name? : string,
    items: string[],
    showItems?: number,
    selected?: (value: string) => void,
    selectedValue?: string | null,
    error? : string | null,
    className? : string,
    style?: Style,
    disabled?: boolean,
    tooltip?: IToolTipOption | null | undefined
}

type RState = {
    yourPick: string,
    isHide: boolean;
}

export class Question extends Component<RadioButtonProps, RState> {
    constructor(props:RadioButtonProps) {
        super(props);
        this.state = {
            yourPick: null == this.props.selectedValue ? "" : this.props.selectedValue + "",
            isHide: true
        };

        this.show.bind(this);
        this.handleRadio.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            yourPick: null == nextProps.selectedValue ? "" : nextProps.selectedValue + ""
        };
    }

    handleRadio(e: any) {
        if (!this.props.disabled) {
            if (this.state.yourPick !== e.target.value) {
                this.setState({ yourPick: e.target.value });
                if (this.props.selected != undefined)
                    this.props.selected(e.target.value);
            }
        }
    }

    show(e: { target: { value: any; }; }) {
        this.setState({ isHide: false});
    }

    renderTooltip(props: any) {
        return <Popover id="coveragePopoverBI" className="coverage-tooltip" {...props}>
            <Popover.Title as="h3">{this.props.tooltip?.title}</Popover.Title>
            <Popover.Content>
                {this.props.tooltip?.content}
                </Popover.Content>
        </Popover>;
    }

    render() {
        const {isHide} = this.state;
        const options = this.props.items.map((loan, key) => {
            const isCurrent = this.state.yourPick === loan;
            return (
                <div
                    key={key}
                    className="radioInline"
                    style={{ display: (isHide && (this.props.showItems != undefined ? this.props.showItems <= key : false) 
                        ? (isCurrent ? '' : 'none') : '') }}
                >
                    <div>
                        <label
                            className={
                                isCurrent ?
                                    'radioPad__wrapper radioPad__wrapper--selected' :
                                    'radioPad__wrapper'
                            }
                        >
                            <input
                                className="radioPad__radio"
                                type="radio"
                                name={this.props.name}
                                id={Utilities.uniqueId()}
                                value={loan}
                                onClick={(e) => this.handleRadio(e)}
                            />
                            {loan}
                        </label>
                    </div>
                </div>
            );
        });
        return (
            <div className={"question " + (this.props.className ? this.props.className : "")} style={this.props.style}>
                <Form.Label className={this.props.error ? "is-invalid" : ""}>
                    {this.props.lable}
                    {" "}
                    {
                        this.props.tooltip
                            ?
                            <div style={{ display: "inline-block" }}>
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(props) => this.renderTooltip(props)}>
                                    <i className="fas fa-info-circle"></i>
                                </OverlayTrigger>
                            </div>
                            :
                            null
                    }
                </Form.Label>
                    {options}
                    <div
                    key="999"
                    className="radioInline"
                    style={{ display: (isHide && (this.props.showItems != undefined ? this.props.showItems : false) ? '' : 'none') }}>
                    <div>
                        <label
                            className={'radioPad__wrapper'}>
                            <input
                                className="radioPad__radio"
                                type="radio"
                                name="coffeeTypes"
                                id="999"
                                value="+ SHOW"
                                onChange={(e) => this.show(e)}
                            />
                            + Show more
                        </label>
                    </div>
                    </div>
                {null !== this.props.error && !!this.props.error
                    ? <Form.Control.Feedback type="invalid">
                          {this.props.error}
                    </Form.Control.Feedback>
                    : null
                }
                
            </div>
        );
    }
}
export default Question;
